import React from 'react';
import { Helmet } from 'react-helmet-async';
import SatisfactionSurvey from '../components/SatisfactionSurvey/SatisfactionSurvey';
import './SatisfactionSurvey.css';

const SatisfactionSurveyPage = () => {
  return (
    <>
      <Helmet>
        <title>Memnuniyet Anketi - FlowSky CRM</title>
        <meta
          name="description"
          content="FlowSky CRM memnuniyet anketi. 2 dakikadan kısa sürede geri bildirim bırakın."
        />
      </Helmet>

      <section className="survey-page section">
        <div className="container">
          <div className="survey-page-content">
            <SatisfactionSurvey mode="page" />
          </div>
        </div>
      </section>
    </>
  );
};

export default SatisfactionSurveyPage;

